import { CurrencyPipe, DatePipe } from '@angular/common';
import { BlockScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { MAT_MENU_SCROLL_STRATEGY } from '@angular/material/menu';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'core/api/api.service';
import { appInfoResolver } from 'core/app-info/app-info.resolver';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppStateService } from 'core/app-state/app-state.service';
import { AuthenticationService } from 'core/authentication/authentication.service';
import { ModalComponent } from 'core/dialog/modal/modal.component';
import { LoggerService } from 'core/logger/logger.service';
import { NoticeComponent } from 'core/notification/notice/notice.component';
import { SessionService } from 'core/session/session.service';
import { MatDialog } from '@angular/material/dialog';
import { TouchpointNotificationSnackbarComponent } from 'core/touchpoint-notification/touchpoint-notification-snackbar.component';
import { DsAngularModule } from '@snapon/design-system-angular';
import { NotesModalComponent } from 'core/dialog/notes-modal/notes-modal.component';
import { AppMaterialModule } from './app-material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CrmModule } from './modules/crm/crm.module';
import { MarketingModule } from './modules/marketing/marketing.module';
import { PosModule } from './modules/pos/pos.module';
import { SimpleUploadService } from './modules/pos/quotes/services/simple-upload.service';
import { ImportQuotesAndOrdersComponent } from './modules/shared/import-quotes-and-orders/import-quotes-and-orders.component';
import { NavbarComponent } from './modules/shared/navbar/navbar.component';
import { OfflineProgressBarComponent } from './modules/shared/offline-progress-bar/offline-progress-bar.component';
import { SharedModule } from './modules/shared/shared.module';

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    ImportQuotesAndOrdersComponent,
    NoticeComponent,
    ModalComponent,
    NotesModalComponent,
    OfflineProgressBarComponent,
    TouchpointNotificationSnackbarComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [AppMaterialModule,
    SharedModule,
    BrowserModule,
    CrmModule,
    MarketingModule,
    PosModule,
    AppRoutingModule,
    DsAngularModule],
  providers: [
    LoggerService,
    ApiService,
    SessionService,
    CookieService,
    CurrencyPipe,
    MatDialog,
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: appInfoResolver,
      deps: [AppInfoService, AppStateService, AuthenticationService],
      multi: true
    },
    {
      provide: MAT_SELECT_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay]
    },
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay]
    },
    {
      provide: MAT_MENU_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay]
    },
    SimpleUploadService,
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
  ]
})
export class AppModule { }
